import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../config';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/farms');

export const getCompaniesList = actionCreator.async<{}, {}>('GET_COMPANIES_LIST');
